import React from 'react';
import { connect } from 'react-redux';
import type { SplitTestingState } from '@peloton/split-testing';
import {
  useHeaderBodyImageWithLinkGalleryData,
  useSectionData,
} from '@ecomm/copy/helpers';
import type {
  HeaderBodyImageWithLinkGallery,
  Section,
} from '@ecomm/copy/models.generated';
import type { ReducerState as ToggleState } from '@ecomm/feature-toggle';
import { getIsToggleActive } from '@ecomm/feature-toggle';
import BlogCardsModuleView from './BlogCardsModuleView';

type Props = {
  page: string;
  showcaseBlogContentActive: boolean;
};

const BLOG_CONTENT_AUDIENCE = 'AudienceA';

export const BlogCardsModule: React.FC<React.PropsWithChildren<Props>> = ({
  page,
  showcaseBlogContentActive,
}) => {
  const { title, body } = useSectionData(
    `showcaseBlogContentTitle${BLOG_CONTENT_AUDIENCE}${page}` as Section,
  );

  const blogCards = useHeaderBodyImageWithLinkGalleryData(
    `showcaseBlogContent${BLOG_CONTENT_AUDIENCE}${page}` as HeaderBodyImageWithLinkGallery,
  );

  if (!showcaseBlogContentActive) return null;

  if (blogCards.length === 0) {
    return null;
  }

  return (
    <BlogCardsModuleView
      eyebrow={title}
      heading={body}
      page={page}
      blogCards={blogCards}
    />
  );
};

const mapStateToProps = (state: ToggleState & SplitTestingState) => ({
  showcaseBlogContentActive: getIsToggleActive('showcaseBlogContent')(state),
});

export default connect(mapStateToProps)(BlogCardsModule);
